import { AxiosError } from 'axios';
import { createEffect, sample } from 'effector';
import $$api from 'models/api';
import { navigateFx } from 'models/router-gate';

import AlertsService from 'services/AlertsService';
import { getFileName, saveBlobAsFile } from 'utils/common-helper';

sample({
    clock: [
        $$api.documents.generateFx.failData,
        $$api.documents.getDocumentValidityFx.failData.filter({
            fn: (error) => !(error instanceof AxiosError && error.response?.status === 404),
        }),
        $$api.documents.createDocumentFx.failData,
        $$api.documents.deleteScanFx.failData,
        $$api.documents.downloadDocumentFx.failData,
        $$api.documents.getDocumentsByEmailFx.failData,
        $$api.documents.getJSONbyDocIDFx.failData,
        $$api.documents.getSamplesFx.failData,
        $$api.documents.updateStatusFx.failData,
        $$api.documents.getSignedUrlByDocumentIdAndNameFx.failData,
        $$api.documents.downloadScanFx.failData,
        $$api.documents.uploadScanFx.failData,
        $$api.documents.generateDocByCodeFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});

// Handle $$api.documents.generate SUCCESS
sample({
    source: $$api.documents.generateFx.done.map(({ params, result: { job_id } }) => ({
        qInstanceId: params.questionnaireInstanceId,
        job_id,
    })),
    fn: ({ qInstanceId, job_id }) => `/docs-generation?job=${job_id}&qInstanceId=${qInstanceId}`,
    target: navigateFx,
});

// Handle $$api.documents.downloadDocument SUCCESS
sample({
    source: $$api.documents.downloadDocumentFx.doneData,
    target: createEffect(({ blob, headers }: { blob?: any; headers: any }) => {
        saveBlobAsFile(blob, getFileName(headers));
    }),
});

// Handle $$api.documents.download SUCCESS
sample({
    source: $$api.documents.downloadScanFx.doneData,
    target: createEffect(({ blob, headers }: { blob?: any; headers: any }) => {
        saveBlobAsFile(blob, getFileName(headers, 'docx'));
    }),
});
